import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Image from "next/image";
import Link from "next/link";
import enrolmentImg from "../../public/images/enrollment/Flyer_matriculas.jpg";
import pricing2024Img from "../../public/images/enrollment/precios_2024.png";




const Enrolment = () => {
  return (
    <>
      <PageHead title="Matrículas - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Matrículas - 2025" text="Matrículas" />
          <div className="bg-color-white rbt-section-gapTopHalf">
            <div className="container">
              <div className="row g-5 align-items-center">
                <div className="col-lg-6">
                  <Image
                    className="w-100 rbt-radius"
                    src={enrolmentImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Mattilda flyer"
                  />
                </div>
                <div className="col-lg-6">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <div className="section-title text-start">
                      <h4 className="title">Conoce el proceso e información relevante </h4>
                      <p className="description mt--20 mb--20">
                        Te invitamos a visitar nuestro campus, conocer a nuestro equipo, nuestras instalaciones y compartir detalles sobre nuestro programa educativo. Después de esta visita, agendaremos una entrevista para iniciar el proceso de selección para el año 2025.
                      </p>
                      <p className="description mb--20">
                        Para conocer mejor a tu hijo/a, solicitaremos observadores, notas de años anteriores y cualquier información adicional sobre condiciones específicas que debamos saber.
                      </p>
                      <p className="description mb--20">
                        En el 2025, nuestro primer año ofertado será Transición, recibiendo niños con 5 años cumplidos o próximos a cumplir. El último grado ofertado será noveno.
                      </p>
                      <p className="description mb--20">
                        El servicio de restaurante escolar (adicional) ha tenido una muy buena acogida, con más del <b>60%</b> de nuestros estudiantes beneficiándose de él.
                      </p>
                      <p className="description mb--30">
                        Los valores para el 2025 tendrán un aumento entre el 8% y el 10%, dependiendo de los lineamientos emitidos por la Secretaría de Educación.
                      </p>
                      <Image
                        className="w-100 rbt-radius"
                        src={pricing2024Img}
                        width={407}
                        height={638}
                        property="true"
                        alt="Mattilda flyer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gapTopHalf flex-center">
            <div className="container col-lg-8">
              <h4 className="title">
                El Colegio Menfis continúa su compromiso con la educación bilingüe. Contamos con:
              </h4>
              <div className="rbt-feature-wrapper mt--40">
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Aulas semi-personalizadas, con entre 15 y 18 estudiantes por salón.
                    </h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Profesores nativos de Inglaterra, Estados Unidos, Canadá, entre otros, quienes nos acompañarán durante trimestres, brindando un intercambio cultural y enseñando inglés de manera vivencial y experiencial.
                    </h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Jornada completa de lunes a jueves.
                    </h6>
                  </div>
                </div>
                {/* <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Viernes: Horario de 7:00 a.m. a 12:20 p.m.</h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Curso adicional de refuerzo de inglés para estudiantes y familias Menfisianas, con un costo adicional.
                    </h6>
                  </div>
                </div> */}
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Semilleros de investigación: inspiración y aprendizaje en acción. En 2024 contamos con el acompañamiento del SENA en los grados superiores.
                    </h6>
                  </div>
                </div>
              </div>
              <h4 className="title mt--40">
                Además, ofrecemos actividades lúdicas opcionales en:
              </h4>
              <div className="rbt-feature-wrapper mt--30 short-list-items">
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Natación</h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Fútbol mixto</h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center ">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Judo</h6>
                  </div>
                </div>
              </div>
              <h4 className="title mt--30">
                ¡Anímate! El proceso de admisión para el 2025 ya está en marcha.
              </h4>
              <Link 
                className="rbt-moderbt-btn mb--30 mt--15" 
                href='https://forms.gle/obT7hopwBGRPoVaV9' 
                target="_blank"> 
                  Postúlate en el siguiente enlace
              </Link>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Enrolment;
